/* import __COLOCATED_TEMPLATE__ from './emoji-group-buttons.hbs'; */
import Component, { setComponentTemplate } from "@ember/component";
import TEMPLATE from "./emoji-group-buttons.hbs";
export default setComponentTemplate(TEMPLATE, Component.extend({}));